import { useQueryClient } from "@tanstack/react-query";
import {
  PatientIntakeForm,
  PatientIntakeFormControllerApi,
} from "../../../services";
import {
  getConfigObject,
  useMutationWithLoading,
} from "./../../../utils/utils";

type Params = {
  patientIntakeForm: PatientIntakeForm;
  xTENANTID?: string;
  formEntries?: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const usePatientIntakeFormUpdate = (publicView?: boolean) => {
  const queryClient = useQueryClient();
  return useMutationWithLoading(
    async (params: Params) =>
      new PatientIntakeFormControllerApi(
        publicView ? undefined : getConfigObject()
      ).updatePatientIntakeForm(
        params.formEntries || "",
        params.patientIntakeForm,
        params.xTENANTID
      ),
    {
      // Updating an intake form usually changes timeline / requiring-
      // action state on the chart. Invalidate so the Provider Timeline
      // refreshes when this completes inside the same React session.
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["chronological-record"] });
        queryClient.invalidateQueries({ queryKey: ["requiring-action"] });
      },
    }
  );
};
